import { osFetch } from './fetch'

export type V2OrderingRow = {
  distributor: string
  price?: number
  is_in_stock?: boolean
  is_available?: boolean
}

export type V2ComponentBase = {
  id?: number
  code: string
  ordering_v2?: V2OrderingRow[]
}

/**
 * Shared helper for the `componentsv2` GET endpoint.
 *
 * Errors are propagated to the caller (non-2xx and network failures both
 * reject); each caller decides whether to surface them, swallow them, or
 * convert to a fallback. Pass `options.signal` to support cancellation via
 * `AbortController`.
 */
export function fetchComponentsV2<T extends V2ComponentBase = V2ComponentBase>(
  orgId: number,
  filters: Record<string, string>,
  options?: { signal?: AbortSignal }
): Promise<T[]> {
  const queryParams = new URLSearchParams()
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null) queryParams.append(key, value)
  })

  return osFetch(`${window.API_ROOT}/api/orgs/${orgId}/componentsv2/?${queryParams.toString()}`, {
    headers: window.Utils.tokenAuthHeaders({}),
    signal: options?.signal,
  })
    .then((response) => {
      if (!response.ok) throw new Error(`componentsv2 request failed: ${response.status}`)
      return response.json()
    })
    .then((data) => (Array.isArray(data) ? (data as T[]) : []))
}
